var app = angular.module('leonardo');

var BackgroundDirective = function(ConfigThemeService) {
  return {
    restrict: 'A',
     scope: {
      opacity: '='
    },
    link: function (scope, element, attrs) {
      scope.setColor = function () {
        if (!isNull(scope.opacity)) {
          scope.color = ConfigThemeService.getColor(attrs.background, scope.opacity);
        }
        else {
          scope.color = ConfigThemeService.config.theme_config[attrs.background] + '';
        }
        element.css('background-color', scope.color);
      };

      scope.setColor();

      scope.$on('config-theme:updated', function () {
        scope.setColor();
      });

      scope.$watch(function() {
        return element.attr('background');
      }, function(newValue, oldValue){
        if ((newValue !== oldValue) && newValue) {
          scope.setColor();
        }
      });
    }
  };
};

app.directive('background', ['ConfigThemeService', BackgroundDirective]);
